module.exports = "<button (click)=\"selected = !selected\">Escondemelo</button>\r\n\r\n<button [disabled]=\"selected\">Hola</button>"